<script>
	import { page } from '$app/stores';
	import { browser } from '$app/environment';

	import { PUBLIC_URL_PREFIX } from '$env/static/public';

	async function sendLog(logMessage) {
		let url = '/api/log/error';
		if (!browser) {
			// Running on the server, prepend host to URL
			url = `${PUBLIC_URL_PREFIX}${url}`;
		}
		try {
			const response = await fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ log: logMessage })
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			const result = await response.json();
			// console.log('Success:', result);
		} catch (error) {
			console.error('Error:', error);
		}
	}

	// if the env is production, send the log to the server
	if (import.meta.env.MODE === 'production') {
		sendLog(page);
	}

	// Example usage:
	// sendLog('Your log message here');
</script>

<div class="px-6 mt-12 py-32lg:px-8">
	<div class="max-w-6xl mx-auto text-base leading-7">
		<h1 class="text-4xl font-bold text-center text-gray-800">Error</h1>
		<div class="py-4 border-b border-gray-200">
			<p class="text-center text-gray-800">
				We're sorry, but an error has occurred. Please try again later.
			</p>
		</div>
	</div>
</div>
